import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: "AIzaSyAagffV1Fw2XY19Q_Gahce-CWkdHfopQX4",
  authDomain: "breaze-driver-timelines.firebaseapp.com",
  projectId: "breaze-driver-timelines",
  storageBucket: "breaze-driver-timelines.appspot.com",
  messagingSenderId: "906214214911",
  appId: "1:906214214911:web:b262b9ffa3f057635190ca",
  measurementId: "G-JH9D96DT53"
};

const app = initializeApp(firebaseConfig);